import { render, staticRenderFns } from "./dc-screen.vue?vue&type=template&id=4d181441&scoped=true"
import script from "./dc-screen.vue?vue&type=script&lang=js"
export * from "./dc-screen.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=4d181441&prod&scoped=true&lang=css&external"
import style1 from "./dc-screen.vue?vue&type=style&index=1&id=4d181441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d181441",
  null
  
)

export default component.exports